import {shouldEnableSwiper} from '%widgets%/widget-slider';
import {initiateWidgetTabs} from '%widgets%/widget-tabs';
import {initiateSliderCards} from '%widgets%/widget-slider_cards';
import {initiateSliderCarousel} from '%widgets%/widget-slider_carousel';
import {initiateFormRate} from '%modules%/form-rate';
import {initiateUmbracoFormRate} from '%modules%/umbraco-form-rate';
import {initiateWidgetComparison} from '%widgets%/widget-comparison';
import {initiateSliderAlerts} from '%widgets%/widget-slider_alerts';

export const initWidgets = () => {
  document.querySelectorAll('.widget-slider').forEach(widget => {
    if (!widget.querySelector('.swiper')) return;

    const sliderFunctions = {
      'widget-slider_cards': initiateSliderCards,
      'widget-slider_carousel': initiateSliderCarousel,
      'widget-slider_alerts': initiateSliderAlerts,
    };
    let swiperInstance = null;

    const initOrDestroySwiper = () => {
      if (shouldEnableSwiper(widget)) {
        if (!swiperInstance) {
          const className = Object.keys(sliderFunctions).find(className =>
            widget.classList.contains(className)
          );
          if (className) {
            swiperInstance = sliderFunctions[className](widget);
          }
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy();
          swiperInstance = null;
        }
      }
    };

    initOrDestroySwiper();

    window.addEventListener(
      'resize',
      () => {
        initOrDestroySwiper();
      },
      {passive: true}
    );
  });

  document.querySelectorAll('.widget-tabs').forEach(widget => {
    initiateWidgetTabs(widget);
  });

  document.querySelectorAll('.widget-form_rate').forEach(widget => {
    const isUmbracoForms = widget.getAttribute('data-umbraco-forms') === 'true' || false;

    if (isUmbracoForms) {
      initiateUmbracoFormRate(widget);
    } else {
      initiateFormRate(widget);
    }
  });

  document.querySelectorAll('.widget-comparison').forEach(widget => {
    initiateWidgetComparison(widget);
  });
};
